<template>
  <div class="comp-date-shortcut">
    <div
      v-for="(item,index) in items" :key="index"
      class="comp-date-shortcut__item"
      @click="handleItemClick(index)"
    >
      <a
        href="javascript:;"
        v-bind:class="{'comp-date-shortcut__a':true,active:index === active}"
      >{{item.text}}</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array
      },
      onClick: {
        type: Function
      },
      startTime: {
        type: Number
      },
      endTime: {
        type: Number
      }
    },
    data () {
      return {
        active: 0
      };
    },
    methods: {
      handleItemClick (clickIndex) {
        if (this.items[clickIndex].active) {
          return;
        }
        this.active = clickIndex;
        const {values, index} = this.items[this.active];
        this.onClick(values, index);
      },
      setActive (index) {
        if (index || index === 0) {
          this.active = index;
          return false;
        }
        this.active = null;
      },
      isActive () {
        let isMatch = false;
        (this.items || []).forEach((item, i) => {
          const values = item.values;
          if (this.$moment(this.endTime).startOf('days').valueOf() === values[1]
            && this.$moment(this.startTime).startOf('days').valueOf() === values[0]) {
            this.setActive(i);
            isMatch = true;
          }
        });
        if (!isMatch) {
          this.setActive(null);
        }
      }
    },
    watch: {
      'startTime' () {
        this.isActive();
        return false;
      },
      'endTime' () {
        this.isActive();
        return false;
      }
    },
  };
</script>

<style lang="less">
  .comp-date-shortcut {
    .comp-date-shortcut__item {
      display: inline-block;
      padding: 0 15px;
      margin-right: 0;
      cursor: pointer;
    }

    .comp-date-shortcut__a {
      text-decoration: none;
      font-size: 12px;
      color: #016cdf;
      letter-spacing: -0.29px;
    }

    .comp-date-shortcut__a.active {
      color: #333333;
    }
  }

</style>



// WEBPACK FOOTER //
// DateShortCut.vue?867bfef6